module.exports = __webpack_public_path__ + "img/pdf-brander-4.10c27faa.png";